import { Box } from '@mui/material';
import RoleTable from './RoleTable';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';

import './RolesPage.scss';

const RolesPage = () => {

  const { t } = useTranslation();

  return (
    <Box p={3}>
      <PageHeader title={t('user_and_roles_title')} subtitle={t('user_and_roles_description')} />
      <div className="tables-container">
        <div className="table-section">
          <RoleTable />
        </div>
      </div>
    </Box>
  );
};

export default RolesPage;
